

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class Customer extends BaseEntity
{   
    public CardCode: string; 
    public CardName: string; 
    public Obligo: number; 
    public MaxBalance: number; 
    public MaxObligo: number; 
    public IsVatLiable: boolean; 
    public DisplayCurrency: string; 
    public PdfUrl: string; 
    public TradeLicenseNumber: string; 
    public DefaultBank: string; 
    public DefaultBranchCode: string; 
    public DefaultAccount: string;
    public DefaultBankName: string;
    public IsActive: boolean; 
    public CardNumberEnding: string; 
    public CardInfo: string; 
    public Balance: number; 
    public BalanceLate: number; 
    public HasOpenDocuments: boolean;
	
}



